import { createContext } from 'react'
import { DEFAULT_PAGE_CONTEXT } from 'constants/pageContext'

export const PageContext = createContext(DEFAULT_PAGE_CONTEXT)
